export const ANIMATION_BIGGER = 1.2;
export const ANIMATION_SMALLER = 0.9;

export const ANIMATION_APPEAR = {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.2 }
};

export const ANIMATION_OPEN = {
    initial: { height: 0, opacity: 0.8, overflow: 'hidden' },
    animate: { height: 'auto', opacity: 1 },
    transition: { duration: 0.15 }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function conditionalScaleAnimation(condition: boolean, hover: number, tap: number) {
    return condition
        ? {
              whileHover: { scale: hover },
              whileTap: { scale: tap }
          }
        : {
              whileHover: { scale: 1 },
              whileTap: { scale: 1 }
          };
}
